import PropTypes from 'prop-types'
import { Box, Button, LoadingButton, Icon } from '@redriverpress/system'
import useStepper from '../utils/useStepper'

export default function BottomNav({
  prevTitle,
  nextTitle,
  prevLink,
  nextLink,
  disabled,
  loading,
}) {
  const { setNextStep, setPreviousStep } = useStepper()

  const handleNext = () => {
    setNextStep()
    nextLink()
  }

  const handlePrev = () => {
    setPreviousStep()
    prevLink()
  }

  return (
    <Box width={1} mt='auto' mb={4} display='flex' justifyContent='flex-end'>
      <Button
        type='button'
        role='link'
        mr={[2, null, 3]}
        onClick={handlePrev}
        secondary
        adaptive
      >
        <Icon mr={2} icon='arrow-left' />
        {prevTitle}
      </Button>
      <LoadingButton
        type='button'
        role='link'
        loading={loading}
        onClick={handleNext}
        disabled={disabled}
        adaptive
      >
        {nextTitle}
        <Icon ml={2} icon='arrow-right' />
      </LoadingButton>
    </Box>
  )
}

BottomNav.defaultProps = {
  nextTitle: 'Next',
  prevTitle: 'Back',
  disabled: false,
  loading: false,
}

BottomNav.propTypes = {
  nextTitle: PropTypes.string,
  prevTitle: PropTypes.string,
  prevLink: PropTypes.func.isRequired,
  nextLink: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  loading: PropTypes.bool,
}
